import {BaseDtoModel} from '../../../Services/Models/base-model.service';
import {format, startOfWeek} from 'date-fns';

export class ClockInFilters extends BaseDtoModel {
  day!: string;
  id_local!: number;
  todos!: number;
  timeZone!: string;

  constructor(dataJson?: any) {
    super(dataJson);

    this.init({
      day: format(startOfWeek(new Date(), {weekStartsOn: 1}), 'yyyy-MM-dd'),
      id_local: 0,
      todos: 1,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });

    this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
